module.exports = __webpack_public_path__ + "img/food-29.e39d9955.jpg";